import actionTypes from '../actions/shopProfile/actionType';

const initFormData = {
  startTime: '',
  endTime: '',
  insuranceType: '',
  status: '',
};
const initMeansFormData = {
  createTimeEnd: '',
  createTimeStart: '',
  name: '',
  type: '',
};
const initialState = {
  isLoading: false, // loading
  storeDetail: {},
  insuranceForm: initFormData,
  meansForm: initMeansFormData,
  activeTabKey: 'DjStore',

  // 签约人/常用联系人
  SignaToryData: {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
    signaTory: [], // 签约人列表
    visible: false, // 查看
    previewStatus: false, // 预览
    previewImage: '', // 身份证照片
  },
  // 股东财务信息
  ShareHolderData: {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
    shareHolder: [], // 股东财务信息列表
    visible: false, // 查看
    delVisible: false, // 删除
  },

  // 函件
  LettersData: {
    pageIndex: 1,
    pageSize: 10,
    total: 0,
    letterList: [], // 保险信息列表
    previewImage: '',
    previewStatus: false,
  },
};
export default (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.UPDATE_ISLOADING:
      return {
        ...state,
        isLoading: action.payload.loading,
      };
    case actionTypes.UPDATE_ACTIVEKEY:
      return {
        ...state,
        activeTabKey: action.payload.key,
      };
    case actionTypes.UPDATE_DETAIL:
      return {
        ...state,
        storeDetail: action.payload.detail,
      };
    case actionTypes.UPDATE_SIGNATORY:
      return {
        ...state,
        SignaToryData: {
          ...action.payload,
        },
      };

    case actionTypes.UPDATE_SHAREHOLDER:
      return {
        ...state,
        ShareHolderData: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_SHAREHOLDER_FORM:
      return {
        ...state,
        ShareHolderForm: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_CONTRACT:
      return {
        ...state,
        ContractData: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_INSURANCE:
      return {
        ...state,
        InsuranceData: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_LETTERS:
      return {
        ...state,
        LettersData: {
          ...action.payload,
        },
      };
    case actionTypes.RESET_INSURNCE_FORM:
      return {
        ...state,
        insuranceForm: { ...initFormData },
      };
    case actionTypes.UPDATE_INSURANCE_FORM:
      return {
        ...state,
        insuranceForm: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_OTHER_MEANS:
      return {
        ...state,
        OtherMeansData: {
          ...action.payload,
        },
      };
    case actionTypes.RESET_MEANS_FORM:
      return {
        ...state,
        meansForm: { ...initMeansFormData },
      };
    case actionTypes.UPDATE_MEANS_FORM:
      return {
        ...state,
        meansForm: {
          ...action.payload,
        },
      };
    case actionTypes.UPDATE_CORPORATION_DATA:
      return {
        ...state,
        CorporationData: {
          ...action.payload,
        },
      };
    default:
      return state;
  }
};
